<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.el-form {
  margin: 220px;
  margin-top: 25px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}
</style>
